import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { AudioRecorder } from 'react-audio-voice-recorder';
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useRef, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { format } from "date-fns";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { IRequirementMast, Job_Type, Mode_Of_Req, Req_Term } from "../../models/RequirementMast";
import { IVendorCompanyInfo } from "../../models/VendorCompanyInfo";
import { ICityMastDropdown, IClientCategoriesDropdown, IEndClientsDropdown, IIndustryMastDropdown, ISkillCategoriesDropdown, IStateMastDropdown, IVisaDropdown } from "../../models/IDropdown";
import { EmptyRequirement } from "../pocTransferReq/EmptyRequirement";
import { Fetch, baseUrl } from "../../shared/Fetch";
import { JVDropdownInput } from "../../shared/JVDropdownInput";
import { JVDropdown } from "../../shared/JVDropdown";
import { JVInput } from "../../shared/JVInput";
import { JVMultiselect } from "../../shared/JVMultiselect";
import { client_Type, EClient_Communication, InterviewProcess, JobType, Positions, Priority, special_Constraints, Term } from "../../models/FDropdown";
import { FileUpload } from "primereact/fileupload";
import { InputTextarea } from "primereact/inputtextarea";
import { IAllRequirements } from "../../models/AllRequirements";
import { Tag } from "primereact/tag";
import { Publish } from "../pocTransferReq/Publish";
import { IModel2 } from "../pocTransferReq/Table";
import { Publishes } from "../pocTransferReq/Publishes";


const schema = yup.object({
    req_Type: yup.string().required("Req Type is required*"),
    req_Job_Title: yup.string().required("Job Title is required*").min(3).max(100, "Max 100 character allowed."),
    req_Term: yup.string().required("Term is required*"),
    req_Duration: yup.string().when('req_Term', val => {
        return (val === "Permanent") ?
            yup.string().nullable() :
            yup.string().required("Duration is required*").max(50, "Max 50 character allowed.")
    }),
    job_Type: yup.string().required("Job Type is required*"),
    state: yup.object().when('job_Type', val => {
        return (val === "Remote") ?
            yup.object().nullable() :
            yup.object().shape({
                state_ID: yup.number().min(1, "State is required*").required("State is required*"),
                state_Name: yup.string().required()
            })
    }),
    city: yup.object().when('job_Type', val => {
        return (val === "Remote") ?
            yup.object().nullable() :
            yup.object().shape({
                city_ID: yup.number().min(1, "City is required*").required("City is required*"),
                city_Name: yup.string().required()
            })
    }),
    req_Rate: yup.string().required("Rate/Salary is required*").max(100, "Max 100 character allowed."),
    endClient: yup.object().nullable(),
    industry_Id: yup.number().min(1, "Industry is Required*").required("Industry is Required*"),
    req_NoOfPositions: yup.string().required("Positions is required*"),
    req_Category: yup.number().min(1, "Skills Category is required*").required("Skills Category is required*"),
    req_Sub_Category: yup.number().required(),
    req_Priority: yup.string().required("Priority is required*"),
    reqType: yup.number().min(1, "Client Category is required*").required("Client Category is required*"),
    travelReq: yup.string().required("Travel Required is required*"),
    req_InterviewProcess: yup.string().required("Interview Process is required*"),
    req_RequiredSkill: yup.string().max(100, "Max 100 character allowed for required skill.").required("RequiredSkill is required*"),
    mode_Of_Req: yup.string().required(" Mode of Req  is required*"),
    client_Type: yup.number().required("Client Type is required*"),
});

interface Iprops {
    singleData: IRequirementMast,
    open: boolean,
    hideDialog: () => void,
    toast: any,
}

export const PocRequirement = (props: Iprops) => {
    const [loading, setLoading] = useState(false);
    const [vendorCompanyInfo, setVendorCompanyInfo] = useState<IVendorCompanyInfo | undefined>(undefined);
    const [visa, setVisa] = useState<Array<IVisaDropdown>>();
    const [industry, setIndustry] = useState<Array<IIndustryMastDropdown>>();

    const [cities, setCities] = useState<Array<ICityMastDropdown>>();
    const [states, setStates] = useState<Array<IStateMastDropdown>>();
    const [endClients, setEndClients] = useState<Array<IEndClientsDropdown>>();
    const [skillCategories, setSkillCategories] = useState<Array<ISkillCategoriesDropdown>>();
    const [clientCategories, setClientCategories] = useState<Array<IClientCategoriesDropdown>>();
    const [description, setDescription] = useState("");
    const [additionInfo, setAdditionInfo] = useState("");
    const [formValues, setFormValues] = useState({ isJTermP: false, isJTypeR: false } as { isJTermP: boolean, isJTypeR: boolean });
    const [selectedVisa, setSelectedVisa] = useState<Array<IVisaDropdown>>();

    const [shwSkillDrp, setShwSkillDrp] = useState<any | null>(null);
    const [contactPersonDetails, setContactPersonDetails] = useState<any>();

    const [mode, setMode] = useState<any>(false);
    const [reasonValue, setReasonValue] = useState<string>("");
    const [image, setImage] = useState(false);
    const [selectedEClient_Communication, setSelectedEClient_Communication] = useState<Array<{ name: string }>>();
    const [imageType, setImageType] = useState<string>("");
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IRequirementMast>, loading: boolean });
    const [disable, setDisable] = useState<boolean>(true);
    const [subskillCategories, setSubSkillCategories] = useState<Array<ISkillCategoriesDropdown>>();
    const [specialConstraints, setSpecialConstraints] = useState<Array<{ name: string }>>();
    const [resumeFile, setResumeFile] = useState<File | null | any>(null);
    const [showDialog, setShowDialog] = useState(false);
    const [tableData1, setTableData1] = useState({ tableData: [], loading: true });
    const [clickedJobIds, setClickedJobIds] = useState<number[]>([]);


    const [publish, setPublish] = useState({ singleData: {}, open: false } as IModel2);
    const [publish1, setPublish1] = useState({ singleData: {}, open: false } as IModel2);

    const hidePublishDialog = () => {
        setPublish({ singleData: {}, open: false });
        setPublish1({ singleData: {}, open: false });

    };
    const dt = useRef<any>(null);

    const { control, handleSubmit, watch, getValues, formState: { errors }, reset, setValue } = useForm<IRequirementMast>({
        resolver: yupResolver(schema),
        defaultValues: EmptyRequirement,
        shouldFocusError: false
    });

    const onUpload = (event: any) => {
        const file = event.files[0];
        setImageType(event.files[0].type.split("/")[1]);

        if (event.files[0].type === "image/png" || event.files[0].type === "image/jpeg" || event.files[0].type === "image/jpg") {
            if (event.files[0].size > 1024 * 1024 * 2) {
                props.toast.current.show({ severity: 'error', content: "Image File should be less than 2 MB." });
                event.options.clear();
            } else {
                setResumeFile(file);
                setImage(true);

                event.options.clear();
            }
        } else {
            props.toast.current.show({ severity: 'error', content: "Please Choose A Image File." });
            setImage(true);

            event.options.clear();
        }

        setResumeFile(file);
        props.toast.current.show({ severity: 'success', summary: 'Success', detail: "Screenshot Saved", life: 3000 });

    };

    const loadSubSkillCategories = async (parent_id: number) => {
        const response = await Fetch("Dropdown/skillsSubCategories", "GET", null, `parent_id=${parent_id}`, null);
        if (response) {
            const data: Array<ISkillCategoriesDropdown> = await response.json();
            setSubSkillCategories(data);
        }
    }


    useEffect(() => {

        if (skillCategories) {
            const subscription = watch((value, { name }) => {
                if (name === "req_Category") {
                    if (value.req_Category != 0 && value.req_Category != null) {
                        loadSubSkillCategories(value.req_Category);
                    }
                }
                if (name === "req_Sub_Category") {
                    if (value.req_Sub_Category != 0 && value.req_Sub_Category != null) {
                        handleSubCategoryChange(value.req_Sub_Category, props.singleData.pV_Contact_PersonID_Email ?? '');
                    }
                }
                if (name === "req_Term") {
                    if (value.req_Term === Req_Term.Permanent) setFormValues((val) => { return { ...val, isJTermP: true } });
                    else setFormValues((val) => { return { ...val, isJTermP: false } });
                } else if (name === "job_Type") {
                    if (value.job_Type === Job_Type.Remote) setFormValues((val) => { return { ...val, isJTypeR: true } });
                    else setFormValues((val) => { return { ...val, isJTypeR: false } })
                }
            });
            return () => subscription.unsubscribe();
        }
    }, [watch, skillCategories, props.singleData.pV_Contact_PersonID_Email]);

    useEffect(() => {
        loadVisa();
        loadIndsutry();
    }, []);

    useEffect(() => {
        props.singleData.industry_Id = industry?.find(f => f.industry_Name === props.singleData.industry_Name)?.industry_Id ?? 0;
        props.singleData.req_Category = skillCategories?.find(f => f.req_CategoryName === props.singleData.req_Category_Name)?.req_CategoryID ?? 0;
        setDescription(props.singleData.req_JobDescription ?? '');
        if (props.singleData.visa && props.singleData.visa !== "") {
            const visa_Name_Array = props.singleData.visa.split(',');
            const temp_selected_visa = visa?.filter(visa => visa_Name_Array?.includes(visa.visa_Name));
            setSelectedVisa(temp_selected_visa);
        }
        if (props.singleData.special_Constraint && props.singleData.special_Constraint !== "") {
            const sc_Array = props.singleData.special_Constraint.split(',');
            const temp_selected_sc = special_Constraints.filter(sc => sc_Array.includes(sc.name));
            setSpecialConstraints(temp_selected_sc);
        }
        if (props.singleData.req_Category) loadSubSkillCategories(props.singleData.req_Category);
        reset(props.singleData);
        props.singleData.pV_Contact_PersonID_Email && Check(props.singleData.pV_Contact_PersonID_Email);
    }, [props.singleData]);

    const loadVisa = async () => {
        const response = await Fetch("Dropdown/visa", "GET", null, null, null);
        if (response) {
            const data: Array<IVisaDropdown> = await response.json();
            setVisa(data);
        }
    }
    const loadIndsutry = async () => {
        const response = await Fetch("Dropdown/industries", "GET", null, null, null);
        if (response) {
            const data: Array<IIndustryMastDropdown> = await response.json();
            setIndustry(data);
        }
    }

    const loadCities = async (filter: string | null) => {
        if (control._formValues.state?.state_ID) {
            const response = await Fetch("Dropdown/cities", "GET", null, `filter=${filter}&state_id=${control._formValues.state.state_ID}`, null);
            if (response) {
                const data: Array<ICityMastDropdown> = await response.json();
                setCities(data);
            }
        } else {
            props.toast.current.show({ severity: 'error', detail: "Select the State First.", life: 3000 });
        }
    }
    const completeMethodCities = (event: { query: string }) => {
        loadCities(event.query);
    }

    const loadStates = async (filter: string | null) => {
        const response = await Fetch("Dropdown/states", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<IStateMastDropdown> = await response.json();
            setStates(data);
        }
    }
    const completeMethodStates = (event: { query: string }) => {
        loadStates(event.query);
    }

    const loadEndClient = async (filter: string | null) => {
        const response = await Fetch("Dropdown/endClients", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<IEndClientsDropdown> = await response.json();
            setEndClients(data);
        }

    }
    const completeMethodEndClient = (event: { query: string }) => {
        loadEndClient(event.query);
    }

    const loadSkillCategories = async () => {
        const response = await Fetch("Dropdown/skillsCategories", "GET", null, null, null);
        if (response) {
            const data: Array<ISkillCategoriesDropdown> = await response.json();
            setSkillCategories(data);
        }
    }

    const loadClientCategories = async () => {
        const response = await Fetch("Dropdown/clientCategories", "GET", null, null, null);
        if (response) {
            const data: Array<IClientCategoriesDropdown> = await response.json();
            setClientCategories(data);
        }
    }

    useEffect(() => {
        loadClientCategories();
        loadSkillCategories();
    }, []);

    const saveToDB = async (body: IRequirementMast) => {
        setLoading(true);
        const method = props.singleData?.req_ID ? "PUT" : "POST";
        const message = props.singleData?.req_ID ? "Updated Successfully" : "Added Successfully";
        body.req_City = body.city?.city_ID;
        body.req_State = body.state?.state_ID;
        body.pV_Contact_PersonID = contactPersonDetails.contact_Person_Id;
        body.req_EndClient = body.endClient?.end_Client_Name;
        body.endClient_ID = body.endClient?.end_Client_Id;
        body.req_JobDescription = description;
        body.city_Name = body.city?.city_Name;
        body.state_Name = body.state?.state_Name;
        body.vendor_Company_Name = body.client_company?.vendor_Company_Name;
        body.req_Category_Name = skillCategories?.find(d => d.req_CategoryID === body.req_Category)?.req_CategoryName;
        body.industry_Name = industry?.find(d => d.industry_Id === body.industry_Id)?.industry_Name;
        body.additional_info = additionInfo;
        body.mode_Of_Req_Comment = reasonValue;

        delete body.city;
        delete body.state;
        delete body.client_company;
        delete body.endClient;
        if (method === "POST") { delete body.req_EditedBy; delete body.req_Allocated_By }

        const req_updates = JSON.stringify(body);
        body.req_Publish_Status = req_updates;

        const formData = new FormData();
        formData.append('screenshot', resumeFile);
        formData.append('requirement_MAST1', JSON.stringify(body));
        const params = {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            },
            body: formData
        };
        const response = await fetch(`${baseUrl}POCTransferReq?typeoffile=${imageType}`, params);
        if (response) {
            const messageText = await response.text();
            if (messageText === "Can't Update") {
                props.toast.current.show({ severity: 'error', detail: "Submission is Done on this Requirement, Can't Update.", life: 3000 });
                onHide();
            } else {
                props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
                onHide();
            }
        }
        setLoading(false);
    }
    function onSubmit(data: IRequirementMast) {
        if (!resumeFile) {
            props.toast.current.show({ severity: 'error', content: "Please Upload Screenshot First." });

        }
        else if (contactPersonDetails.contact_Person_Id === 0) {
            props.toast.current.show({ severity: 'error', detail: "Choose a Client Contact Person!", life: 3000 });
        } else if (description.length === 0) {
            props.toast.current.show({ severity: 'error', detail: "Fill the Job Description!", life: 3000 });
        } else if (selectedVisa === undefined || selectedVisa.length === 0) {
            props.toast.current.show({ severity: 'error', detail: "Choose Work Authorization!", life: 3000 });
        } else {
            data.visa = "";
            selectedVisa.forEach((visa, index) => {
                if (index < (selectedVisa.length - 1)) data.visa += (visa.visa_Name + ",");
                else data.visa += visa.visa_Name;
            });

            if (selectedEClient_Communication === undefined || selectedEClient_Communication.length === 0) {
                props.toast.current.show({ severity: 'error', detail: "Choose EClient Communication!", life: 3000 });
            } else {
                data.client_Communication = "";
                selectedEClient_Communication.forEach((item, index) => {
                    if (index < (selectedEClient_Communication.length - 1)) data.client_Communication += (item.name + ",");
                    else data.client_Communication += item.name;
                });
                if (!image) {
                    // props.toast.current.show({ severity: 'error', content: "Please Upload the ScreenShot First." })
                } else {
                    if (data.mode_Of_Req === Mode_Of_Req.Other && (reasonValue === "" || reasonValue.length <= 9)) props.toast.current.show({ severity: 'error', content: "Please Enter Comment for Mode Other." })
                }

                if (specialConstraints === undefined || specialConstraints.length === 0) {
                    props.toast.current.show({ severity: 'error', detail: "Choose Special Constraints", life: 3000 });
                } else {
                    data.special_Constraint = "";
                    specialConstraints.forEach((item, index) => {
                        if (index < (specialConstraints.length - 1)) data.special_Constraint += (item.name + ",");
                        else data.special_Constraint += item.name;
                    });
                    saveToDB(data);
                }
            }
        }

    }


    const onHide = () => {
        props.hideDialog();
        let emptyRequirement = EmptyRequirement;
        emptyRequirement.req_Category = 0;
        emptyRequirement.req_Category_Name = '';
        reset(emptyRequirement);
        setDescription('');
        setAdditionInfo('');
        setVendorCompanyInfo(undefined);
        setFormValues({ isJTermP: false, isJTypeR: false });
        setSelectedVisa(undefined);
        setSelectedEClient_Communication(undefined);
        setShwSkillDrp(null);
        setDisable(true);
        setReasonValue("");
        setMode(false);
        setImage(false);
        setTableData({ tableData: [], loading: false });
        setSpecialConstraints(undefined);
        setResumeFile(null);
    }



    const onClear = () => {
        let emptyRequirement = EmptyRequirement;
        if (props.singleData.req_ID != 0) {
            emptyRequirement.req_Category = shwSkillDrp?.req_CategoryID;
            emptyRequirement.req_Category_Name = shwSkillDrp?.req_CategoryName;
        }
        reset(emptyRequirement);
        setDescription("");
        setAdditionInfo("");
        setFormValues({ isJTermP: false, isJTypeR: false });
        setSelectedVisa(undefined);
        setSpecialConstraints(undefined);

    }


    const dFooter = () => {
        return (
            <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                <Button disabled={disable} loading={loading} style={{ width: '100px' }} label="SAVE" form="requirementForm" type="submit"></Button>
                <Button style={{ width: '100px' }} label="CLEAR" onClick={onClear} type="button" className="p-button-outlined surface-200		"></Button>
            </div>
        );
    }

    const uploadAudio = async (blob: Blob) => {
        let formData = new FormData();
        formData.append("audio", blob);

        const params = {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            },
            body: formData
        };
        const response = await fetch(`${baseUrl}Requirement_MAST/audio`, params);
        if (response) {
            props.toast.current.show({ severity: 'success', content: "Audio Uploaded Successfully." });
        }
    }
    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "mode_Of_Req") {
                if (value.mode_Of_Req === Mode_Of_Req.Other) setMode(true);
                else setMode(false);
            }
        });
        return () => subscription.unsubscribe();
    }, [watch]);


    const Check = async (email: string) => {
        setContactPersonDetails({});
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!emailPattern.test(email)) {
            props.toast.current.show({ severity: 'error', detail: 'Invalid email format', life: 3000 });
            return;
        }

        const response = await Fetch("POCTransferReq", "GET", null, `email=${email}`, props.toast);
        if (response) {
            const data: any = await response.json();
            setContactPersonDetails(data.pocuser);
            setTableData({ tableData: data.reqList, loading: false });
            props.toast.current.show({ severity: 'success', detail: `This Client Contact Person is with - ${data.pocuser.user_Name}`, life: 3000 });
            setDisable(false);
        } else {
            setDisable(true);
        }
    }


    const req_Job_Title = (rowData: IAllRequirements) => {

        return rowData.poC_Transfer_Req === 3 ?
            <span onClick={() => {
                setPublish({ singleData: rowData, open: true });
            }}
                className="cursor-pointer underline">
                <Tag severity="danger" value={rowData.req_Job_Title} />
            </span>
            : rowData.poC_Transfer_Req == 2 ? <span onClick={() => setPublish({ singleData: rowData, open: true })}
                className="cursor-pointer underline">
                <Tag severity="success" value={rowData.req_Job_Title} />
            </span> : <span onClick={() => setPublish({ singleData: rowData, open: true })}
                className="cursor-pointer text-cyan-700 underline">
                {rowData.req_Job_Title}
            </span>;
    };

    const req_Job_Title1 = (rowData: IAllRequirements) => {
        const handleClick = (e: React.MouseEvent) => {
            e.stopPropagation();
            setPublish1({ singleData: rowData, open: true });
            setClickedJobIds((prev: any) => {
                if (!prev.includes(rowData.req_ID)) {
                    return [...prev, rowData.req_ID];
                }
                return prev;
            });
        };

        return rowData?.poC_Transfer_Req === 3 ? (
            <span onClick={handleClick} className="cursor-pointer underline">
                <Tag severity="danger" value={rowData?.req_Job_Title} />
            </span>
        ) : rowData?.poC_Transfer_Req === 2 ? (
            <span onClick={handleClick} className="cursor-pointer underline">
                <Tag severity="success" value={rowData?.req_Job_Title} />
            </span>
        ) : (
            <span onClick={handleClick} className="cursor-pointer text-cyan-700 underline">
                {rowData?.req_Job_Title}
            </span>
        );
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Requirements Posted In Last 15 Days</h5>
            <span className="block mt-2 md:mt-0 p-input-icon-left">

            </span>
        </div>
    );

    const handleSubCategoryChange = async (subCategoryId: number, email: string) => {
        const categoryId = getValues("req_Category");
        const response = await Fetch("POCTransferReq/getTodayPostedreqss", "GET", null, `contactPersonEmail=${email}&reqCategoryId=${categoryId}&reqSubCategoryId=${subCategoryId}`, props.toast);

        if (response) {
            const data = await response.json();
            if (data?.length > 0) {
                setTableData1({ tableData: data, loading: false });
                setShowDialog(true);
            } else {
                setShowDialog(false);
            }
        }
    };


    return (
        <>
            <Dialog visible={props.open} style={{ width: '80vw' }} header="Add POC Requirement" footer={dFooter} className="p-fluid" maximizable onHide={onHide}>

                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                    ref={dt} size="small" stripedRows showGridlines responsiveLayout="scroll" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                    resizableColumns columnResizeMode="expand"
                    scrollable scrollHeight="30vh"
                    value={tableData.tableData}
                    emptyMessage="No Requirements found."
                    header={header}
                    loading={tableData.loading}
                >
                    <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                    <Column field="req_ID" header="Req.ID" sortable />
                    <Column field="req_Job_Title" sortable header="Job Title" body={req_Job_Title} />
                    <Column field="req_Duration" header="Duration" />
                    <Column field="location" header="Location" />
                    <Column field="req_CategoryName" header="Category" sortable />
                    <Column field="req_Sub_CategoryName" header="Sub Category" sortable />
                    <Column field="req_Term" header="Job Term" body={(rowData: IAllRequirements) => rowData.req_Term ? Req_Term[rowData.req_Term] : ""} />
                    <Column field="job_Type" header="Job Type" body={(rowData: IAllRequirements) => rowData.job_Type ? Job_Type[rowData.job_Type] : ""} />
                    <Column field="pDate" header="Posted On" body={(e) => <p>{format(new Date(e.pDate), 'dd/MM/yyyy').toUpperCase()}</p>} />
                    <Column field="user_Name" sortable header="Sales Manager" />
                    <Column field="recruiter" header="Recruiter" />
                    <Column field="req_EndClient" sortable header="End Client" />
                    <Column field="client_Communication" sortable header="Client Communication" />
                </DataTable>
                <br />
                <form id="requirementForm" onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid" style={{ marginTop: "10px" }}>
                    <JVDropdown column={4} label="Req Type" control={control} name="req_Type" error={errors.req_Type?.message} options={[{ name: "Normal" }, { name: "Tough" }]} optionLabel="name" optionValue="name" placeholder="Select Req Type" />
                    <JVDropdown column={4} required label="Mode" control={control} name="mode_Of_Req" error={errors.mode_Of_Req?.message} options={[{ name: "Portal" }, { name: "Mail" }, { name: "Other" }]} optionLabel="name" optionValue="name" placeholder="Select Mode of Req" />
                    {(mode === true && <div className="field col-12 md:col-6 mt-5">
                        <InputTextarea value={reasonValue} onChange={(e) => setReasonValue(e.target.value)} rows={10} cols={20} placeholder="Enter Comment" />
                        {reasonValue?.length <= 9 && <small className="p-error" >Minimum 10 Characters Required*</small>}
                    </div>)}
                    {vendorCompanyInfo && <div className="field col-12 md:col-3" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        {vendorCompanyInfo.blacklisted ? <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '30px', width: '30px', border: "1px solid #ccc", borderRadius: '50%', margin: '0px 5px', background: 'red' }}></span>
                            : <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '30px', width: '30px', border: "1px solid #ccc", borderRadius: '50%', margin: '0px 5px', background: 'green' }}></span>}
                        <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '30px', width: '30px', border: "1px solid #ccc", borderRadius: '50%', margin: '0px 5px' }}>{vendorCompanyInfo.noOfReq}</span>
                        <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '30px', width: '30px', border: "1px solid #ccc", borderRadius: '50%', margin: '0px 5px' }}>{vendorCompanyInfo.noOfSub}</span>
                        <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '30px', width: '30px', border: "1px solid #ccc", borderRadius: '50%', margin: '0px 5px' }}>{vendorCompanyInfo.noOfECI}</span>
                        <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '30px', width: '30px', border: "1px solid #ccc", borderRadius: '50%', margin: '0px 5px' }}>{vendorCompanyInfo.noOfPo}</span>
                    </div>}
                    <div style={{ marginTop: '10px', marginBottom: '20px', width: '100%' }}></div>

                    <JVInput required column={3} label="Job Title" control={control} name="req_Job_Title" error={errors.req_Job_Title?.message} />
                    <JVDropdown required column={3} label="Job Term" control={control} name="req_Term" error={errors.req_Term?.message} options={Term.filter((e, idx) => idx !== 0)} optionLabel="name" optionValue="name" placeholder="Select Term" />
                    {!formValues.isJTermP && <JVInput required column={3} label="Duration" control={control} name="req_Duration" error={errors.req_Duration?.message} />}
                    <JVDropdown required column={3} label="Job Type" control={control} name="job_Type" error={errors.job_Type?.message} options={JobType.filter((e, idx) => idx !== 0)} optionLabel="name" optionValue="name" placeholder="Select Job Type" />
                    <JVDropdownInput required={!formValues.isJTypeR} column={3} completeMethod={completeMethodStates} label="State" control={control} name="state" error={errors.state?.state_ID?.message} options={states} optionLabel="state_Name" placeholder="Search State" />
                    <JVDropdownInput required={!formValues.isJTypeR} column={3} completeMethod={completeMethodCities} label="City" control={control} name="city" error={errors.city?.city_ID?.message} options={cities} optionLabel="city_Name" placeholder="Search City" />
                    <JVInput required column={3} label={formValues.isJTermP ? "Salary" : "Rate"} control={control} name="req_Rate" error={errors.req_Rate?.message} />
                    <JVDropdownInput column={3} completeMethod={completeMethodEndClient} label="End Client" control={control} name="endClient" error={errors.endClient?.end_Client_Id?.message} options={endClients} optionLabel="end_Client_Name" placeholder="Search End Client" />
                    <JVDropdown column={3} required label="Industry Type" control={control} name="industry_Id" options={industry} optionLabel="industry_Name" optionValue="industry_Id" placeholder="Select Industry Type" error={errors.industry_Id?.message} />
                    <JVDropdown required column={3} label="Positions" control={control} name="req_NoOfPositions" error={errors.req_NoOfPositions?.message} options={Positions} optionLabel="name" optionValue="name" placeholder="Select Positions" />
                    <JVDropdown required column={3} label="Skills Category" control={control} name="req_Category" error={errors.req_Category?.message} options={skillCategories} optionLabel="req_CategoryName" optionValue="req_CategoryID" placeholder="Select Skills Category" />
                    <JVDropdown column={3} label="Sub Category" control={control} name="req_Sub_Category" error={errors.req_Sub_Category?.message} options={subskillCategories} optionLabel="req_CategoryName" optionValue="req_CategoryID" placeholder="Select Sub Category" />

                    <JVDropdown required column={3} label="Priority" control={control} name="req_Priority" error={errors.req_Priority?.message} options={Priority.filter((e, idx) => idx !== 0)} optionLabel="name" optionValue="name" placeholder="Select Priority" />
                    <JVDropdown required column={3} label="Client Category" control={control} name="reqType" error={errors.reqType?.message} options={clientCategories} optionLabel="reqType" optionValue="reqType_ID" placeholder="Select Client Category" />
                    <JVDropdown required column={3} label="Client Type" control={control} name="client_Type" options={client_Type} optionLabel="clientTypeName" optionValue="id" error={errors.client_Type?.message} placeholder="Select Client Type" />
                    <JVMultiselect column={3} label="Work Authorization" options={visa} optionLabel="visa_Name" placeholder="Select Visa" required value={selectedVisa} onChange={setSelectedVisa} />
                    <JVInput required type={"number"} column={3} label="Travel Required" control={control} name="travelReq" error={errors.travelReq?.message} />
                    <JVDropdown required column={3} label="Interview Process" control={control} name="req_InterviewProcess" error={errors.req_InterviewProcess?.message} options={InterviewProcess.filter((e, idx) => idx !== 0)} optionLabel="name" optionValue="name" placeholder="Select Interview Process" />
                    <JVMultiselect column={3} required label="Special Constraints" options={special_Constraints} optionLabel="name" value={specialConstraints} onChange={setSpecialConstraints} placeholder="Select Special Constraints " />

                    <JVMultiselect column={3} label="Client Communication" options={EClient_Communication.filter((e, idx) => idx !== 0)} optionLabel="name" placeholder="Select Client Communication" required value={selectedEClient_Communication} onChange={setSelectedEClient_Communication} />
                    <JVInput column={3} required label="Skills Required" control={control} name="req_RequiredSkill" error={errors.req_RequiredSkill?.message} />
                    <div className="field col-12 md:col-2">
                        <label>Record Your Message</label>
                        <AudioRecorder onRecordingComplete={uploadAudio} />
                    </div >
                    <div className="field col-12 md:col-2">
                        <label>Upload Screenshot<small className="p-error" >*</small></label>
                        <FileUpload chooseLabel="Choose Screenshot" mode="basic" name="screenshot" accept="image/*" customUpload uploadHandler={onUpload} auto />
                    </div>
                    <div className="col-12 md:col-12 md:col-6">
                        <label htmlFor="req_JobDescription">Job Description<span style={{ color: 'red' }}>*</span></label>
                        <CKEditor editor={ClassicEditor} data={description} onChange={(event, editor) => { setDescription(editor.getData()); }} />
                    </div>
                    <div className="col-12 md:col-12 md:col-6 mt-4">
                        <label htmlFor="req_JobDescription">Additional Info:<span style={{ color: 'red' }}>*</span></label>
                        <CKEditor editor={ClassicEditor} data={additionInfo} onChange={(event, editor) => { setAdditionInfo(editor.getData()); }} />
                    </div>
                </form>
            </Dialog>
            <Publish singleData={publish.singleData} open={publish.open} hideDialog={hidePublishDialog} toast={props.toast} />
            <Publishes singleData={publish1.singleData} open={publish1.open} hideDialog={hidePublishDialog} toast={props.toast} />

            <Dialog
                header="Similar Reqs of the same Category and Subcategory with this PV posted today."
                visible={showDialog}
                style={{ width: '60vw' }}
                onHide={() => {
                    const allJobIds = tableData1.tableData.map((row: any) => row.req_ID);
                    const allClicked = allJobIds.every((id) => clickedJobIds.includes(id));
                    if (allClicked) {
                        setShowDialog(false);
                        setClickedJobIds([]);
                    } else {
                        props.toast.current?.show({
                            severity: 'warn',
                            detail: 'Please view all job titles before closing.',
                            life: 3000,
                        });
                    }
                }}
                closable={tableData1.tableData.every((row: any) => clickedJobIds.includes(row.req_ID))}
                dismissableMask={false}
                modal
            >
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                    ref={dt} size="small" stripedRows showGridlines responsiveLayout="scroll" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                    resizableColumns columnResizeMode="expand"
                    scrollable scrollHeight="30vh"
                    value={tableData1.tableData}
                    emptyMessage="No Requirements found."
                    loading={tableData1.loading}
                >
                    <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                    <Column field="req_ID" header="Req.ID" sortable />
                    <Column field="req_Job_Title" sortable header="Job Title" body={req_Job_Title1} />
                    <Column field="req_Duration" header="Duration" />
                    <Column field="location" header="Location" />
                    <Column field="req_CategoryName" header="Category" sortable />
                    <Column field="req_Sub_CategoryName" header="Sub Category" sortable />
                    <Column field="req_Term" header="Job Term" body={(rowData: IAllRequirements) => rowData.req_Term ? Req_Term[rowData.req_Term] : ""} />
                    <Column field="job_Type" header="Job Type" body={(rowData: IAllRequirements) => rowData.job_Type ? Job_Type[rowData.job_Type] : ""} />
                    <Column field="pDate" header="Posted On" body={(e) => <p>{format(new Date(e.pDate), 'dd/MM/yyyy').toUpperCase()}</p>} />
                    <Column field="user_Name" sortable header="Sales Manager" />
                    <Column field="recruiter" header="Recruiter" />
                    <Column field="req_EndClient" sortable header="End Client" />
                    <Column field="client_Communication" sortable header="Client Communication" />
                </DataTable>
                <p style={{ fontWeight: 'bold', color: '#1f2937', backgroundColor: '#fef08a', padding: '6px', borderRadius: '6px' }}>
                    View the Req JD to proceed
                </p>
            </Dialog>

        </>
    );
}